const ko = {
  nav: {
    about: "회사 소개",
    services: "서비스",
    partners: "파트너",
    contact: "문의하기",
    contactBtn: "문의하기",
  },
  hero: {
    tagline: "일본 시장 진출 전문가",
    title1: "일본 시장의 문을",
    title2: "함께 열어드립니다.",
    subtitle: "We open the door to Japan's market, together.",
    description: "해외 브랜드의 가능성을 극대화하는 일본 최고의 총대리점 파트너.",
    descriptionEn: "Maximizing the potential of overseas brands — Japan's premier general agency partner.",
    cta: "문의하기",
    ctaEn: "Contact Us",
    scroll: "스크롤",
  },
  about: {
    label: "WHO WE ARE",
    labelJa: "회사 소개",
    title: "Our Mission",
    titleEn: "Message from CEO",
    quote: "일본 시장의 문을 함께 열어드립니다.",
    p1: "저희는 우수한 해외 브랜드와 일본 시장을 연결하는 전문가 집단입니다. 단순한 수입 대리점이 아닌, 브랜드 가치를 지키면서 일본 시장에 뿌리내리게 하는 전략적 파트너입니다.",
    p2: "해외 제조사가 일본 시장에서 직면하는 과제——언어 장벽, 복잡한 법규제, 유통 네트워크 구축——이 모든 것을 저희가 전담합니다. 귀사의 브랜드가 일본에서 빛날 수 있도록 전력으로 지원합니다.",
    p3: "저희는 대기업이 아닙니다. 그렇기에 한 기업 한 기업과 진지하게 마주하며, 스피드와 유연성을 갖춰 지원할 수 있습니다. 중소기업만의 기동력을 살려 해외 제조사의 일본 시장 진출을 세심하고 실천적으로 지원합니다.",
    name: "야마다 타로",
    title2: "대표이사 CEO",
    more: "회사 소개 보기",
    moreEn: "Learn More About Us",
    stat1: "20+",
    stat1Label: "대응 국가",
    stat2: "100+",
    stat2Label: "거래 기업",
    stat3: "15년",
    stat3Label: "실적 연수",
    stat4: "98%",
    stat4Label: "계속 거래율",
  },
  services: {
    label: "OUR SERVICES",
    labelJa: "서비스 내용",
    title: "일본 시장 진출의 전 과정을",
    title2: "원스톱으로.",
    titleEn: "End-to-end support for your Japan market entry.",
    s1Title: "크라우드펀딩 사업",
    s1TitleEn: "Crowdfunding Business",
    s2Title: "EC 사업",
    s2TitleEn: "E-Commerce Business",
    s3Title: "SNS 마케팅・광고 운용",
    s3TitleEn: "SNS Marketing & Advertising",
    s4Title: "법규제 및 인증 지원",
    s4TitleEn: "Regulatory & Compliance",
    s5Title: "고객 지원",
    s5TitleEn: "Customer Support",
    viewAll: "서비스 상세 보기",
    viewAllEn: "View All Services",
    backToHome: "홈으로 돌아가기",
    pageTitle: "우리의 서비스",
    pageTitle2: "상세",
    pageDescription: "전략 수립부터 실행까지 해외 브랜드의 일본 시장 진출을 종합 지원합니다. 20년 이상의 경험과 전문 지식으로 귀사의 비즈니스를 성공으로 이끕니다.",
    detail: {
      s1: {
        title: "크라우드펀딩 사업",
        titleEn: "Crowdfunding Business",
        desc: "Makuake, Campfire 등 일본 주요 크라우드펀딩 플랫폼을 활용하여 해외 제품의 일본 시장 데뷔를 성공으로 이끕니다. 프로젝트 설계부터 운영·PR 지원까지 일관되게 서포트합니다.",
        item1: "Makuake·Campfire 등 플랫폼 출품 전략 수립 및 프로젝트 설계",
        item2: "일본어 카피라이팅 및 비주얼 콘텐츠 제작",
        item3: "크라우드펀딩 기간 중 SNS·PR 운영",
        item4: "서포터 대응·리턴 발송·애프터 팔로우 관리",
      },
      s2: {
        title: "EC 사업",
        titleEn: "E-Commerce Business",
        desc: "아마존 재팬·라쿠텐·Yahoo! 쇼핑 등 일본 주요 EC 플랫폼으로의 출점부터 운영까지, 해외 브랜드의 EC 사업을 포괄적으로 지원합니다. 매출 극대화를 위한 전략적 운영을 실현합니다.",
        item1: "아마존·라쿠텐·Yahoo! 쇼핑 출점 및 스토어 구축",
        item2: "상품 페이지 최적화 (SEO·이미지·카피라이팅)",
        item3: "재고 관리·물류·FBA 활용을 통한 효율적 운영",
        item4: "광고 운용 (스폰서 광고·쿠폰·세일 전략)",
      },
      s3: {
        title: "SNS 마케팅・광고 운용",
        titleEn: "SNS Marketing & Advertising",
        desc: "Instagram·TikTok·X(구 Twitter)·YouTube 등 각 SNS 플랫폼의 특성을 살린 전략적 마케팅과 광고 운용으로 브랜드 인지도 향상과 구매 촉진을 실현합니다.",
        item1: "각 SNS 플랫폼에 최적화된 콘텐츠 제작·게시 운영",
        item2: "인플루언서 마케팅 및 타이업 기획",
        item3: "Meta 광고·Google 광고·TikTok 광고 운용 및 최적화",
        item4: "데이터 분석 기반 PDCA 사이클 및 효과 측정 리포트",
      },
      s4: {
        title: "법규제 및 인증 지원",
        titleEn: "Regulatory & Compliance",
        desc: "일본 특유의 복잡한 법규제 및 인증 취득을 전문 팀이 전면 지원합니다. 리스크를 최소화하고 원활한 시장 진출을 실현합니다.",
        item1: "약기법, 식품위생법, 전파법 등 법규 대응",
        item2: "JIS 규격, SG 마크 등 각종 인증 취득 지원",
        item3: "수입 절차 및 세관 대응 지원",
        item4: "제품 라벨링 및 표시 의무 컴플라이언스 확인",
      },
      s5: {
        title: "고객 지원",
        titleEn: "Customer Support",
        desc: "일본어와 영어로 대응하는 전문 지원팀이 최종 사용자 문의 대응, 불만 처리, 애프터서비스까지 종합 지원합니다. 브랜드 신뢰성을 높이고 고객 만족도 향상에 기여합니다.",
        item1: "일본어·영어 대응 멀티링구얼 고객 지원",
        item2: "문의 관리 시스템 구축 및 운영",
        item3: "불만 처리·반품·교환 프로세스 정비",
        item4: "고객 만족도 조사 및 피드백 분석",
      },
    },
    ctaTitle: "무료 상담으로 시작하세요",
    ctaDescription: "전문 컨설턴트가 귀사의 브랜드에 가장 적합한 일본 시장 진출 전략을 무료로 제안해 드립니다.",
    ctaButton: "무료 상담 신청",
  },
  achievements: {
    label: "ACHIEVEMENTS",
    labelJa: "사업 실적",
    title: "사업 실적",
    titleEn: "Our Business Achievements",
    ec: {
      title: "국내 이커머스 사업",
      titleEn: "Domestic E-commerce Business",
      description: "자사 이커머스 사이트 운영 및 주요 이커머스 플랫폼 입점을 통해 국내외 우수한 상품을 일본 소비자에게 전달하고 있습니다. 연간 매출액은 꾸준한 성장세를 보이며 안정적인 사업 기반을 구축하고 있습니다.",
    },
    web: {
      title: "웹사이트 구축 및 운영",
      titleEn: "Website Development & Operations",
      description: "기업을 대상으로 고품질 웹사이트의 기획, 디자인, 개발, 운영을 원스톱으로 제공합니다. 반응형 대응, SEO 최적화, 접근성 대응 등 최신 기술과 디자인으로 클라이언트의 디지털 프레즌스를 강화합니다.",
    },
  },
  partners: {
    label: "TRUSTED BY",
    labelJa: "거래 실적",
    title: "전 세계 20개국 이상,",
    title2: "100개 이상의 파트너 기업.",
    titleEn: "Trusted by 100+ companies across 20+ countries.",
    note: "※ 일부 거래처를 게재하고 있습니다",
    regions: {
      northAmerica: "북미",
      europe: "유럽",
      asia: "아시아",
      oceania: "오세아니아",
      middleEast: "중동",
    },
  },
  contact: {
    label: "CONTACT US",
    labelJa: "문의하기",
    title: "문의 양식",
    titleEn: "Dedicated Inquiry Window for Overseas Manufacturers",
    englishAvailable: "영어 대응 가능 / English Available",
    companyName: "회사명 / Company Name",
    yourName: "성함 / Your Name",
    email: "이메일 / Email",
    phone: "전화번호 / Phone",
    country: "국가/지역 / Country",
    message: "문의 내용 / Message",
    messagePlaceholder: "문의 내용을 입력해 주세요.\nPlease describe your inquiry.",
    submit: "전송하기 / Submit",
    submitting: "전송 중...",
    successTitle: "전송 완료 / Message Sent",
    successMsg: "문의해 주셔서 감사합니다. 담당자가 2영업일 이내에 연락드리겠습니다.\nThank you for your inquiry. Our team will contact you within 2 business days.",
    directContact: "직접 연락",
    directContactEn: "Direct Contact",
    hours: "평일 9:00 - 18:00 (JST)",
    address: "〒100-0001 도쿄도 치요다구 치요다 1-1-1\n글로벌 비즈니스 타워 15F",
    required: "필수",
    selectCountry: "국가/지역 선택",
    charLimit: "500자 이내",
  },
  process: {
    label: "PROCESS / 거래 흐름",
    title: "거래 흐름",
    subtitle: "첫 문의부터 판매 시작까지, 신속하고 세심하게 지원합니다.",
    timelineLabel: "TIMELINE",
    timelineTitle: "표준 단계",
    faqLabel: "FAQ",
    faqTitle: "자주 묻는 질문",
    ctaTitle: "편하게 상담해 주세요",
    ctaSubtitle: "제품이나 거래 조건에 대한 질문 등, 편하게 문의해 주세요.",
    ctaButton: "문의하기",
    navLink: "거래 흐름",
    steps: {
      s1Title: "문의",
      s1TitleEn: "Inquiry",
      s1Desc: "편하게 문의해 주세요. 제품 정보와 판매 목표에 대해 말씀해 주세요.",
      s2Title: "시장 분석・제안",
      s2TitleEn: "Analysis & Proposal",
      s2Desc: "일본 시장에서의 가능성을 분석하고 최적의 판매 전략을 제안합니다. 경쟁 조사와 가격대 분석도 실시합니다.",
      s3Title: "계약・판매 시작",
      s3TitleEn: "Contract & Launch",
      s3Desc: "계약 체결 후 즉시 판매 준비를 시작합니다. 크라우드펀딩과 EC몰 입점을 신속하게 진행합니다.",
      s4Title: "운영・지원",
      s4TitleEn: "Operation & Support",
      s4Desc: "판매 시작 후에도 지속적인 지원을 제공합니다. 재고 관리, 고객 지원, 마케팅 실행까지 일관 대응합니다.",
    },
    timeline: {
      t1: "문의・첫 미팅",
      t2: "시장 분석・판매 전략 수립",
      t3: "제안・계약 체결",
      t4: "판매 준비（페이지 제작・재고 준비）",
      t5: "판매 시작・운영 지원",
    },
    faq: {
      q1: "계약 기간은 얼마나 됩니까?",
      a1: "프로젝트의 규모와 내용에 따라 유연하게 대응합니다. 크라우드펀딩만의 단기 계약도 가능합니다.",
      q2: "어떤 종류의 제품을 취급합니까?",
      a2: "가전제품, 가젯, 라이프스타일 용품, 의류 등 다양하게 취급합니다. 먼저 편하게 상담해 주세요.",
      q3: "재고는 어떻게 관리됩니까?",
      a3: "일본 국내 창고에서 재고를 보관·관리하며, 주문에 따라 배송합니다. 재고 현황은 실시간으로 확인 가능합니다.",
      q4: "판매 시작까지 얼마나 걸립니까?",
      a4: "계약 체결 후 약 2개월 정도면 판매 시작이 가능합니다. 크라우드펀딩의 경우 준비 기간이 단축될 수 있습니다.",
    },
  },
  strengths: {
    s1: "연 매출 3000만 엔 이상의 판매 실적",
    s2: "3년 이상의 국내 이커머스 사업 경험",
    s3: "아마존·라쿠텐·Yahoo! 등에서의 EC 판매 경험",
    s4: "대기업이 할 수 없는 신속한 의사결정",
    s5: "풍부한 웹사이트 구축 및 광고 수익 실적",
  },
  footer: {
    description: "해외 브랜드의 가능성을 극대화하는 일본 최고의 총대리점 파트너. 20년 이상의 실적과 100개 이상의 거래 기업으로 귀사의 브랜드를 일본 시장으로.",
    quickLinks: "빠른 링크",
    office: "사무소",
    legal: "법적 정보",
    privacy: "개인정보 처리방침",
    terms: "이용약관",
    tokushoho: "특정상거래법에 근거한 표기",
    copyright: "© 2026 SHOP-MK. All Rights Reserved.",
  },
  legal: {
    backHome: "홈으로 돌아가기",
    lastUpdated: "최종 업데이트",
  },
  aboutPage: {
    title: "회사 소개",
    heroSub: "해외 브랜드와 일본 시장을 잇는 전략적 파트너로서.",
    missionLabel: "OUR MISSION",
    missionTitle: "세계의 혁신을 일본에 전달합니다.",
    missionText1: "「사업을 키우고 싶지만, 새로운 시장으로 확장할 여유가 없다.」",
    missionText2: "저희가 일본 시장을 귀사의 비즈니스에 전달해 드립니다.",
    missionText3: "저희는 귀사 브랜드의 일본 총대리점이자 파트너입니다. 판매, 마케팅, 물류, 고객 지원까지 모두 맡겨주세요.",
    missionText4: "먼저 크라우드펀딩으로 시장 반응을 확인하고, 호응을 얻은 후 EC몰로 본격 전개합니다.",
    missionText5: "귀사는 제품에만 집중하세요. 일본이라는 새로운 시장이 비즈니스에 추가됩니다.",
    missionCta: "귀사 브랜드의 다음 단계를 함께 만들어 나갑시다.",
    bridgeTitle: "세계와 일본을 잇는 다리",
    bridgeText1: "저희는 브랜드 대리점 사업, EC 운영 사업, 광고 운영 사업을 통해 해외 제조사의 일본 시장 진출을 종합 지원하는 종합 상사입니다.",
    bridgeText2: "회사명 'GlobalBridge'에는 전 세계 파트너와 함께 성장하고자 하는 바람이 담겨 있습니다.",
    bridgeText3: "미국 제품 수입 판매에서 쌓은 경험과 노하우를 바탕으로, 해외 제조사의 일본 시장 진출을 전면적으로 지원합니다.",
    strengthsLabel: "OUR STRENGTHS",
    strengthsTitle: "우리의 강점",
    strengthSubtitle: "확실한 실적과 경험",
    businessLabel: "OUR BUSINESS",
    businessTitle: "3대 사업",
    companyInfoTitle: "사업 개요",
    info: {
      companyName: "사업소명",
      companyNameValue: "SHOP-MK",
      established: "설립",
      establishedValue: "2025년 1월",
      representative: "대표자명",
      representativeValue: "키사 마사히로",
      repProfile: "대표자 소개",
      repText1: "대학 졸업 후 국내 기업의 시스템 엔지니어로 14년간 근무. 개발·구축 경험을 쌓으며 20개 이상의 프로젝트 매니저를 담당.",
      repText2: "부업으로 블로그 사이트 운영 3년, 라이터 업무, 동영상 편집자로도 수익화에 성공.",
      repText3: "이후 아마존 물판에도 도전하여 주로 중고품 판매 사업에서 일정한 성과를 거두고 독립. 개인으로 연 매출 약 3000만 엔을 달성.",
      repText4: "현재 해외 제조사 총대리점으로서 각국 제조사와 상담을 진행 중.",
      revenue: "연 매출",
      revenueValue: "3000만 엔（추정）",
    },
    ctaTitle: "편하게 문의해 주세요",
    ctaText: "파트너십이나 취급 제품에 대한 문의 등, 편하게 연락해 주세요.",
    ctaButton: "문의하기",
  },
};

export default ko;
